import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { Spinner, Alert, Modal } from '../../components/UI';
import { useConfirm } from '../../components/ConfirmProvider';

export default function Departments() {
  const confirm = useConfirm();
  const [departments, setDepartments] = useState(null);
  const [error, setError] = useState('');
  const [modal, setModal] = useState(null); // {id?, name}
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    try { setDepartments(await api.get('/departments')); } catch (e) { setError(e.message); }
  }

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (modal.id) await api.put(`/departments/${modal.id}`, { name: modal.name });
      else await api.post('/departments', { name: modal.name });
      setModal(null);
      await load();
    } catch (e) { setError(e.message); }
    setSaving(false);
  }

  async function remove(d) {
    if (!(await confirm({ title: 'Delete department', message: `Delete department “${d.name}”?`, confirmText: 'Delete', danger: true }))) return;
    try { await api.del(`/departments/${d.id}`); await load(); } catch (e) { setError(e.message); }
  }

  if (!departments && !error) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="eyebrow">Configuration</div>
          <h1>Departments</h1>
        </div>
        <button className="btn btn-primary" onClick={() => setModal({ name: '' })}>Add department</button>
      </div>

      <Alert type="danger">{error}</Alert>

      <div className="table-wrap">
        <table>
          <thead><tr><th>Name</th><th>Active questions</th><th></th></tr></thead>
          <tbody>
            {(departments || []).map(d => (
              <tr key={d.id}>
                <td>{d.name}</td>
                <td className="mono">{d.question_count}</td>
                <td className="table-actions">
                  <button className="btn btn-outline btn-sm" onClick={() => setModal({ id: d.id, name: d.name })}>Edit</button>
                  <button className="btn btn-danger btn-sm" onClick={() => remove(d)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={modal.id ? 'Edit department' : 'Add department'} onClose={() => setModal(null)}>
          <form onSubmit={save}>
            <div className="form-group">
              <label>Department name</label>
              <input type="text" value={modal.name} onChange={e => setModal({ ...modal, name: e.target.value })} required autoFocus />
            </div>
            <div className="modal-actions">
              <button type="button" className="btn btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
